import React, { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';

const SearchContext = createContext();

export const useSearchContext = () => {
    const context = useContext(SearchContext);
    if (!context) {
        throw new Error('useSearchContext must be used within SearchProvider');
    }
    return context;
};

export const SearchResultProvider = ({
    children,
    dataSource,
    popularSearchWidgetId,
    previewSearchWidgetId,
    popularSearchSorting,
    popularSearchMaxItems,
    searchItemsPerPage,
    searchResultWidgetId
}) => {
    const getDefaultKeyword = () => {
        if (typeof window !== 'undefined') {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get('q') || '';
        }
        return '';
    };

    const [filterItems, setFilterItems] = useState([]);
    const [activeFilter, setActiveFilter] = useState('');
    const [currentKeyword, setCurrentKeyword] = useState(getDefaultKeyword());
    const [totalSearchResults, setTotalSearchResults] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [autoCorrectSuggestion, setAutoCorrectSuggestion] = useState('');

    const clearSearch = () => {
        // setSearchQuery('');
        // setSearchResults([]);
        // setError(null);
        // setPage(1);
    };

    const value = {
        filterItems,
        setFilterItems,
        activeFilter,
        setActiveFilter,
        clearSearch,
        dataSource,
        searchResultWidgetId,
        popularSearchWidgetId,
        previewSearchWidgetId,
        popularSearchSorting,
        popularSearchMaxItems,
        searchItemsPerPage,
        currentKeyword,
        setCurrentKeyword,
        totalSearchResults,
        setTotalSearchResults,
        currentPage,
        setCurrentPage,
        totalPages,
        setTotalPages,
        autoCorrectSuggestion,
        setAutoCorrectSuggestion
    };

    return (
        <SearchContext.Provider value={value}>
            {children}
        </SearchContext.Provider>
    );
};

SearchResultProvider.propTypes = {
    children: PropTypes.node.isRequired,
    dataSource: PropTypes.string,
    searchResultWidgetId: PropTypes.string,
    popularSearchWidgetId: PropTypes.string,
    previewSearchWidgetId: PropTypes.string,
    popularSearchSorting: PropTypes.string,
    popularSearchMaxItems: PropTypes.number,
    searchItemsPerPage: PropTypes.number
};
